module.exports = __webpack_public_path__ + "static/media/DSC09851_20180710_083-12.3d226acf.jpg";